import axios from 'axios';

import c from '../helpers/constants';
import { getApiKey } from '../helpers/functions';

export function doLogin(customerid: string, key: string) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.LOGIN}?customerid=${encodeURIComponent(customerid)}&key=${key}`,
      method: 'GET',
      headers: {
        'Accept': 'application/json',        
      },
    })
      .then((response: any) => {
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}
export function getCustomerDetails(customerid: string, key: string) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.CUSTOMER_DETAILS}?customerid=${encodeURIComponent(customerid)}&key=${key}`,
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'x-api-key': getApiKey()
      },
    })
      .then((response: any) => {
        
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

export function getCustomerDeliveryAddresses(customerid: string) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.CUSTOMER_DELIVERY_ADDRESSES}?customerid=${encodeURIComponent(customerid)}`,
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'x-api-key': getApiKey()
      },
    })
      .then((response: any) => {
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

